import { resolveResponsiveParameter, resolveCommonProps } from "../utils/index.js";
function resolveMasonryProps(containerWidth, { columns, ...rest }) {
  return {
    ...rest,
    ...resolveCommonProps(containerWidth, rest),
    columns: resolveResponsiveParameter(columns, containerWidth, [5, 4, 3, 2], 1)
  };
}
export {
  resolveMasonryProps as default
};
